import "./style.less";
export default function AccountBookingsController(
    user,
    $scope,
    $q,
    Users,
    siteService,
    localStorageService,
    Scroll,
    Bookings
) {
    const filterBookingByStatus = (bookings) => {
        bookings.forEach((booking) => {
            booking._status = null;

            const statuses = new Set(
                booking.bookingPeriods.map((bp) => bp.status)
            );

            if (statuses.size === 1) {
                booking._status = statuses.values().next().value;
            } else {
                booking._status = "mixed";
            }
        });

        return bookings;
    };

    $scope.construct = function () {
        $scope.activeNav = "bookings";

        $scope.siteService = siteService;

        $scope.bookings = [];

        const viewMode = localStorageService.get("my-bookings-view-mode")
            ? localStorageService.get("my-bookings-view-mode")
            : 1;
        $scope.viewMode = viewMode; // 1: List, 2: Grouped

        $q.all({
            bookings: Users.getBookings(user.id),
        }).then(
            (res) => {
                let bookings = filterBookingByStatus(
                    res.bookings.items.reverse()
                );

                bookings.forEach((booking) => {
                    // remove non-completed booking periods
                    booking.bookingPeriods = booking.bookingPeriods.filter(
                        (x) => x.status != "New"
                    );

                    booking.bookingPeriods.forEach((bp) => {
                        // Find booking for the period
                        if (!bp.booking) {
                            // Copy booking object to the period
                            bp.booking = JSON.parse(
                                JSON.stringify(
                                    bookings.find((x) => x.id === bp.bookingId)
                                )
                            );
                            bp.booking.bookingPeriods = null;
                        }
                    });
                });

                $scope.bookings = bookings;
            },
            (err) => {
                $scope.error = err.data.detail;
            }
        );
    };

    $scope.construct(); // hoisting

    Scroll.to("title-focus", siteService.headerHeight + 15);

    $scope.toggleFilter = (viewMode) => {
        $scope.viewMode = viewMode;

        localStorageService.set("my-bookings-view-mode", $scope.viewMode);
    };
}
